<a
  *ngIf="option && !loading && (!active ||
  (active && !option.isCeasable))"
  class="rs-btn"
  [ngClass]="isPayDateInFuture ? 'rs-btn-disabled' : ''"
  (click)="addToCart()"
  >{{ 'option.details.order' | translate }}</a
>
<a
  href="javascript:void(0)"
  *ngIf="option && !loading && active &&
   option.isCeasable"
      class="rs-btn"
  (click)="addToCart()"
  >{{ ceaseLabelKey | translate }}
</a>

<a href="javascript:void(0)" *ngIf="loading" class="rs-btn rs-btn-waiting rs-btn-large"
  >{{ (active && !isOSDOption ? 'option.details.ceasing' : 'option.details.loading') | translate }}
  <div class="rs-btn-waiting-dots"></div>
</a>
